module.exports = "../fonts/HelveticaNeueLTW01-35Thin.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-35Thin.ttf
// module id = 6fib
// module chunks = 1